import { render, staticRenderFns } from "./NewExpenseCategoryModal.vue?vue&type=template&id=f78dd0e8&scoped=true"
import script from "./NewExpenseCategoryModal.vue?vue&type=script&lang=js"
export * from "./NewExpenseCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./NewExpenseCategoryModal.vue?vue&type=style&index=0&id=f78dd0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78dd0e8",
  null
  
)

export default component.exports